
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getPipelines",
      resolverType: "query",
      routePath: "/getPipelines",
      httpMethod: "POST",
    });
  